import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";

// A gentle, self-updating line for when a person's daily Klair allowance
// comes back. next_reset is the ISO timestamp from the quota API (the next
// UTC midnight). We keep the tone soft: a countdown, never a warning.
function phrase(nextResetIso) {
  if (!nextResetIso) return "Resets tomorrow morning";
  const reset = new Date(nextResetIso);
  if (Number.isNaN(reset.getTime())) return "Resets tomorrow morning";
  const ms = reset.getTime() - Date.now();
  if (ms <= 0) return "Resets any moment now";
  const hours = Math.floor(ms / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  if (hours >= 12) return "Resets tomorrow morning";
  if (hours >= 1) return `Resets in ${hours}h ${mins}m`;
  if (mins >= 1) return `Resets in ${mins} min`;
  return "Resets any moment now";
}

export function QuotaResetNote({ nextReset, className = "", testId = "quota-reset-note" }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 60000);
    return () => clearInterval(t);
  }, []);
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      data-testid={testId}
    >
      <CalendarClock size={13} aria-hidden="true" />
      {phrase(nextReset)}
    </span>
  );
}
